__turbopack_context__.v({
  "block": "FeYiNW_block",
  "paragraphs": "FeYiNW_paragraphs",
  "revivWordmark": "FeYiNW_revivWordmark",
  "shell": "FeYiNW_shell",
  "statGroup": "FeYiNW_statGroup",
  "statLabel": "FeYiNW_statLabel",
  "statValue": "FeYiNW_statValue",
  "statsRow": "FeYiNW_statsRow",
});
